import { STORAGE_USER } from 'constant/app';
import { StorageUtils } from 'utils';

export function hasAuthority(authority: string) {
  const user = StorageUtils.getObject(STORAGE_USER);
  const authorities = user?.profile?.authorities;
  return authorities && authorities.some((el: string) => el === authority);
}

export function hasAnyAuthority(authority: string[]) {
  const user = StorageUtils.getObject(STORAGE_USER);
  const authorities = user?.profile?.authorities;
  return authorities && authorities.some((el: string) => authority.includes(el));
}

export function getInitials(fullName: string) {
  const splitted = fullName.split(' ');
  return (splitted[0].charAt(0) + splitted[1].charAt(0)).toUpperCase();
}